import { render } from "./JoinWaitList.vue?vue&type=template&id=c69c1c0a"
import script from "./JoinWaitList.vue?vue&type=script&lang=js"
export * from "./JoinWaitList.vue?vue&type=script&lang=js"

import exportComponent from "/home/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__